import { useMemo } from 'react';
import { useGameResultStore } from '../services/store/racing-game';
import type { JackpotEvent } from '../utils/racing-game/jackpot.ts';
import { useIsBlockchainVersion } from './useIsBlockchainVersion.ts';
import { usePreviousGameRoundBlockchainResults } from './usePreviousGameRoundBlockchainResults.ts';
import { usePreviousGameRoundWebsocketResults } from './usePreviousGameRoundWebsocketResults.ts';

// TODO: check why it's not in use anymore
export const usePreviousGameRoundResults = () => {
  const blockchainVersion = useIsBlockchainVersion();
  const websocketResults =
    usePreviousGameRoundWebsocketResults(!blockchainVersion);
  const blockchainResults =
    usePreviousGameRoundBlockchainResults(blockchainVersion);
  const jackpotEvent = useGameResultStore(({ data }) => {
    if (!data) return null;
    return data.jackpotEvent ?? data.jackpot_event ?? null;
  }) as JackpotEvent | null;

  const base = blockchainVersion ? blockchainResults : websocketResults;

  return useMemo(
    () => ({
      ...base,
      jackpotEvent,
    }),
    [base, jackpotEvent]
  );
};

export type UsePreviousGameRoundResultsHookResult = ReturnType<
  typeof usePreviousGameRoundResults
>;
